export default __webpack_public_path__ + "static/media/logo-pas-ypf.12ec3628.svg";